import { useParams } from "react-router-dom";
import { useCommand } from "../hooks/commands.hooks";
import { CommandType } from "../types/command.types";
import OrdersSupplyDetailPage from "./OrdersSupplyDetailPage";
import OrdersCommandDetailPage from "./OrdersCommandDetailPage";

const OrdersDetailPage = () => {
    const { id } = useParams();
    const { data: command } = useCommand(id ?? null);
    
    if (command && command.type === CommandType.SUPPLY) {
        return <OrdersSupplyDetailPage />
    }
    if (command) {
        return <OrdersCommandDetailPage />
    }
    return null
}

export default OrdersDetailPage;